module.exports = __webpack_public_path__ + "img/batch-zh.aedf94e3.png";